import "./header.css";
import HeaderImage from "../../assets/header.png";
import data from "./data";
import { useEffect, useState } from "react";

const titles = ["Avanish Kumar Bind", "a Software Engineer", "a Developer"]
function Header() {
    const [currentTitleIndex, setCurrentTitleIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentTitleIndex((prevIndex) => (prevIndex + 1) % titles.length)

        }, 3000)
        return () => clearInterval(interval);
    }, [])

    return (
        <header id="header">
            <div className="container header__container">
                <div className="header__profile">
                    <img src={HeaderImage} alt="Header Profile" />
                </div>
                <h2 className="header__myName">Hi, I'm {titles[currentTitleIndex]}</h2>
                <p>
                    A passionate <strong>Software Engineer</strong> focused on building reliable, scalable, and user-friendly applications across the stack.
                </p>
                <div className="header__cta">
                    <a href="#contact" className="btn primary">Get in touch </a>
                    <a href="#portfolio" className="btn">My Works</a>
                </div>
                <div className="header__socials">
                    {
                        data.map(item => <a key={item.id} href={item.link} target="_blank" rel="noopener noreferre" title={item.tooltip}> {item.icon}</a>)
                    }
                </div>
            </div>
        </header>
    )
}
export default Header;